import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { SingleActionDialogModel } from '../../../interfaces/dialogs/single-action-dialog.model';
import { MatButton } from '@angular/material/button';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

/**
 * 單一按鈕通用dialog組件，對應樣式A
 */
@Component({
  selector: 'app-home-router-dialog',
  standalone: true,
  imports: [MatDialogContent, MatButton, TranslatePipe],
  templateUrl: './home-router-dialog.html',
  styleUrl: './home-router-dialog.scss',
})
export class HomeRouterDialogComponent {

  constructor(
    translateService: TranslateService,
    public dialogRef: MatDialogRef<HomeRouterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SingleActionDialogModel
  ) {}

  close() {
    if (this.data.closeAction) {
      this.data.closeAction();
    } else {
      this.dialogRef.close();
    }
  }

  // 前往舊web預約
  goToOldWeb() {
    window.location.href = 'https://booking.cathay-hcm.com.tw/booking/person';
  }
}
